import ArticleImage from "./components/ArticleImage"
import YouTubePreview from "./components/YoutubePreview"

const youtubeIdFor = (link, truthFul = false) => {
    if (!link) return null
    const reg1 = /youtu\.be\/(.{11})/
    const reg2 = /youtube\.com\/(?:watch|v|embed)(?:\?v)?(?:=|\/)(.{11})/
    if (link.match(reg1)) return link.match(reg1)[1]
    if (link.match(reg2)) return link.match(reg2)[1]
    return !truthFul ? "twEjTF-0GSs" : null
}

const blockContentSerializer = {
    types: {
        youtube: YouTubePreview,
        articleimage: ArticleImage
    }
}

const partial = (func, ...args) => (...rest) => func(...args, ...rest);

const sanityTranslate = (obj, language) => {
    if (!obj) return undefined
    return obj[language] || (typeof obj === "object" ? Object.values(obj)[0] : obj)
}

export { youtubeIdFor, blockContentSerializer, partial, sanityTranslate }